import React, { useState, useEffect } from "react";
import { Modal, Header, Menu, Image } from "semantic-ui-react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { postDatasetRequestAccess } from "../../actions/dataConsoleAction";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/Loader";
import CustomPagination from "./CustomPagination";

const PaginationOthersDataset = ({
  columns,
  data,
  showToaster,
  setDeleteStatus,
  loaderFlag,
  result,
  newResult,
  request,
  statusChange,
  updateLatestDataset,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(7));

  const { loadings, responseDataRequestList, errors, datasetRequestStatus } =
    useSelector((state) => state.requestDatasetReducer || {});

  const datasetStatus = useSelector(
    (state) => state.requestDatasetReducer.datasetRequestStatus
  );

  const { response } = useSelector(
    (state) => state.getDatasetApprovedReducer || {}
  );

  const [openDeleteBox, setopenDeleteBox] = useState(false);
  const [deleteFlag, setdeleteFlag] = useState(false);
  const [deleteDatsetName, setdeleteDatsetName] = useState("");
  const [datasetRowId, setDatasetRowId] = useState("");
  const [displayId, setDisplayId] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (datasetStatus === 200 && deleteFlag) {
      showToaster(
        `Access requested for '${deleteDatsetName}' successfully`,
        "success"
      );
      result(data);
      setDisplayId("status_" + datasetRowId);
      setdeleteFlag(false);
      request(false);
      statusChange(true);
      updateLatestDataset();
    }
    if (datasetStatus === 400) {
      setDeleteStatus(true);
      showToaster("Something went wrong", "error");
    }
  }, [response, datasetStatus, dispatch, deleteFlag]);

  const handleDelete = async (datasetID, dataset) => {
    updateLatestDataset();
    setdeleteDatsetName(dataset);
    setDatasetRowId(datasetID);
    setopenDeleteBox(true);
  };

  const actionDeleteDataset = async () => {
    setdeleteFlag(true);
    setopenDeleteBox(false);
    try {
      updateLatestDataset();
      dispatch(postDatasetRequestAccess({ datasets: [datasetRowId] }));
    } catch (error) {
      console.error("Error in requests DataSet:", error);
    }
  };

  const handleClose = async () => {
    setopenDeleteBox(false);
  };

  const totalItems = data.length;

  return (
    <>
      {loaderFlag && <Loader />}
      <Paper
        className="dataConsoleTable"
        sx={{ height: "100vh", overflowX: "auto" }}
        style={{ boxShadow: "none" }}
      >
        <TableContainer style={{ border: "none" }}>
          <Table
            style={{ borderCollapse: "collapse", border: "none" }}
            className="othersDatasetTable"
          >
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={
                      column.id !== undefined && column.id !== null
                        ? column.id
                        : column.label
                    }
                    sx={{ minWidth: column.minWidth }}
                    style={{ minWidth: column.minWidth, borderBottom: "none" }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell style={{ borderBottom: "none" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody data-cy="dataset-others-list-cy">
              {data.length > 0
                ? data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow
                        key={row.datasetName}
                        style={{ marginRight: 8 }}
                      >
                        {columns.map((column) => (
                          <TableCell key={column.id}>
                            {column.id === "files" ? (
                              row[column.id].length > 0 ? (
                                <span className="dataset-count-row">
                                  {row[column.id][0].length < 20
                                    ? row[column.id][0]
                                    : row[column.id][0].slice(0, 17) +
                                      "..." +
                                      (row[column.id].length < 2
                                        ? ""
                                        : "  +" +
                                          (row[column.id].length - 1) +
                                          " more  ")}
                                </span>
                              ) : (
                                "" + "  -"
                              )
                            ) : column.id === "accessUsers" ? (
                              row[column.id].length > 0 ? (
                                <span className="pendingApproval">
                                  <img
                                    src="/images/pending-approval.svg"
                                    alt="Delete"
                                  />
                                  {row[column.id][0].accessType ===
                                  "RequestPending"
                                    ? "Pending Approval"
                                    : row[column.id][0].accessType ===
                                      "Denied"
                                    ? "Rejected"
                                    : ""}
                                </span>
                              ) : (
                                <>
                                  {displayId === "status_" + row.id ? (
                                    <span className="pendingApproval">
                                      <img
                                        src="/images/pending-approval.svg"
                                        alt="Delete"
                                      />
                                      Pending Approval
                                    </span>
                                  ) : (
                                    <span className="NotRequested">
                                      <img
                                        src="/images/not-requested.svg"
                                        alt="Delete"
                                      />
                                      Not Requested
                                    </span>
                                  )}
                                </>
                              )
                            ) : (
                              row[column.id]
                            )}
                          </TableCell>
                        ))}
                        <TableCell>
                          {row["accessUsers"].length > 0 &&
                          row["accessUsers"][0].accessType ===
                            "RequestPending" ? (
                            <>
                              <img
                                className="tableButton"
                                src="/images/disable-key-icon.svg"
                                alt="Approval Pending"
                                data-cy="dataset-delete-link"
                              />

                              <img
                                className="tableButtonHover"
                                src="/images/disable-key-icon.svg"
                                alt="Approval Pending"
                                style={{ cursor: "pointer" }}
                                data-cy="dataset-delete-link"
                              />
                            </>
                          ) : (
                            <>
                              {displayId === "status_" + row.id ? (
                                <img
                                  className="tableButton"
                                  src="/images/disable-key-icon.svg"
                                  alt="Approval Pending"
                                  data-cy="dataset-request-link"
                                />
                              ) : (
                                <>
                                  <img
                                    className="tableButton"
                                    src="/images/key-icon.svg"
                                    alt="Approval Pending"
                                    onClick={() =>
                                      handleDelete(row.id, row.datasetName)
                                    }
                                    style={{ cursor: "pointer" }}
                                    data-cy="dataset-request-link"
                                  />

                                  <img
                                    className="tableButtonHover"
                                    src="/images/blue-key-icon.svg"
                                    alt="Approval Pending"
                                    onClick={() =>
                                      handleDelete(row.id, row.datasetName)
                                    }
                                    style={{ cursor: "pointer" }}
                                    data-cy="dataset-request-link"
                                  />
                                </>
                              )}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                : ""}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomPagination
          totalItems={totalItems}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
        />
      </Paper>

      <Modal
        open={openDeleteBox}
        onClose={handleClose}
        size="tiny"
        className="add-document-model deletePopup requestPopup"
      >
        <Modal.Content>
          <Header as="h3">Request Access</Header>
          <p>
            Are you sure you want to request dataset access for "
            {deleteDatsetName}"
          </p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="cancel-dataset-request"
          >
            Cancel
          </button>
          <button
            className="add-btn"
            onClick={actionDeleteDataset}
            data-cy="cancel-dataset-request"
          >
            Request
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default PaginationOthersDataset;
